import at from "assets/flags/AT.svg"
import de from "assets/flags/DE.svg"
import { StaticImageData } from "next/image"
import { Img } from "src/components/unstyled/Img"
import { StorefrontCountry } from "src/types/storefront"

const countryCodeToFlag: Record<string, StaticImageData> = { de, at }

export type CountryFlagProps = {
  country: StorefrontCountry
}

export const CountryFlag = ({ country }: CountryFlagProps) => {
  const img = countryCodeToFlag[country.code]

  const Component = img ? Img : "div"

  return <Component src={img?.src} alt={country.name} className="h-4 w-6" />
}
